var _path, _path2, _path3, _path4, _path5, _path6, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMostCloudyNight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23591 26.8351C18.6619 26.8351 27.1138 18.3528 27.1138 7.88937C27.1138 6.39548 26.9415 4.94198 26.6158 3.54778C26.2214 1.85943 27.7278 0.167238 29.2618 0.975319C35.9033 4.47393 40.4335 11.4621 40.4335 19.5122C40.4335 31.067 31.1 40.434 19.5865 40.434C11.4139 40.434 4.33961 35.7143 0.922322 28.8425C0.149838 27.2892 1.87839 25.8192 3.55912 26.2492C5.0547 26.6317 6.62164 26.8351 8.23591 26.8351Z",
    fill: "url(#paint0_linear_59_27066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 69H34.5H36H55.5C64.6127 69 72 61.6127 72 52.5C72 43.3873 64.6127 36 55.5 36C55.1382 36 54.7791 36.0116 54.4231 36.0346C50.6566 28.879 43.1481 24 34.5 24C23.6003 24 14.5107 31.7504 12.4418 42.0409C5.48057 42.5806 0 48.4003 0 55.5C0 62.9558 6.04416 69 13.5 69Z",
    fill: "#E7F1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 69H34.5H36H55.5C64.6127 69 72 61.6127 72 52.5C72 43.3873 64.6127 36 55.5 36C55.1382 36 54.7791 36.0116 54.4231 36.0346C50.6566 28.879 43.1481 24 34.5 24C23.6003 24 14.5107 31.7504 12.4418 42.0409C5.48057 42.5806 0 48.4003 0 55.5C0 62.9558 6.04416 69 13.5 69Z",
    fill: "url(#paint1_linear_59_27066)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 69H34.5H36H55.5C64.6127 69 72 61.6127 72 52.5C72 43.3873 64.6127 36 55.5 36C55.1382 36 54.7791 36.0116 54.4231 36.0346C50.6566 28.879 43.1481 24 34.5 24C23.6003 24 14.5107 31.7504 12.4418 42.0409C5.48057 42.5806 0 48.4003 0 55.5C0 62.9558 6.04416 69 13.5 69Z",
    fill: "url(#paint2_linear_59_27066)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.5C0 48.0442 6.04416 42 13.5 42H18C27.9411 42 36 50.0589 36 60V69H13.5C6.04416 69 0 62.9558 0 55.5Z",
    fill: "url(#paint3_radial_59_27066)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46.5C12 34.0736 22.0736 24 34.5 24C46.9264 24 57 34.0736 57 46.5C57 58.9264 46.9264 69 34.5 69C22.0736 69 12 58.9264 12 46.5Z",
    fill: "url(#paint4_radial_59_27066)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 52.5,
    r: 16.5,
    fill: "url(#paint5_radial_59_27066)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_27066",
    x1: 37.3518,
    y1: 38.7644,
    x2: 39.0293,
    y2: -0.616951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56298,
    stopColor: "#EEB82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB649",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_27066",
    x1: 22.5,
    y1: 34.5,
    x2: 36,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89AFD1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_27066",
    x1: 32.0998,
    y1: 70.5925,
    x2: 31.1538,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257422,
    stopColor: "#93C2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_59_27066",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 69) rotate(-127.875) scale(28.5044 32.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.683784,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_59_27066",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5 64.5) rotate(-90) scale(40.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598765,
    stopColor: "#C7DFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B97E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_59_27066",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7 64.6) rotate(-56.3099) scale(31.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47771,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostCloudyNight);
export default __webpack_public_path__ + "static/media/MostCloudyNight.bd3c1aba54f8163778215c56b6e95916.svg";
export { ForwardRef as ReactComponent };